<template>
  <div class="knowledge-repo-page">
    <title-bar title="试卷详情">
      <el-button type="primary" @click="assign">立即布置</el-button>
    </title-bar>
    <question-detail-content v-if="paperDetail" :paperDetail="paperDetail"></question-detail-content>
    <question-type-select-popup @change="navToExamOrPracticeAssign" :visible.sync="selectPopupVisible">
    </question-type-select-popup>
    <assign-exam-popup
      :id="id"
      :name="paperName"
      :total-questions="totalQuestions"
      :visible.sync="assignExamPopupVisible"
      @back="backTypeSelect"
    ></assign-exam-popup>
    <assign-practice-popup
      :id="id"
      :name="paperName"
      :visible.sync="assignPracticePopupVisible"
      @back="backTypeSelect"
    ></assign-practice-popup>
  </div>
</template>
<script lang="ts">
import { BasePage, Component, Prop } from 'kuaidong-component'
import TitleBar from '@/components/TitleBar.vue'
import { ExamQuestionType, IPaperDetail } from 'kuaidong-model'
import { AWinter2023 } from 'kuaidong-api'
import QuestionDetailContent from './components/QuestionDetailContent.vue'
import QuestionTypeSelectPopup from './components/TypeSelectPopup.vue'
import AssignExamPopup from '@/views/pe-knowledge/components/AssignExamPopup.vue'
import AssignPracticePopup from '@/views/pe-knowledge/components/AssignPracticePopup.vue'
@Component({
  components: {
    TitleBar,
    QuestionDetailContent,
    QuestionTypeSelectPopup,
    AssignExamPopup,
    AssignPracticePopup,
  },
})
export default class KnowledgeExamDetailPage extends BasePage {
  @Prop({ type: String, required: true })
  id!: string

  paperDetail: IPaperDetail | null = null

  selectPopupVisible = false

  assignExamPopupVisible = false
  assignPracticePopupVisible = false

  get paperName() {
    if (this.paperDetail) {
      return this.paperDetail.title
    } else {
      return ''
    }
  }

  get totalQuestions() {
    if (this.paperDetail) {
      return `${this.paperDetail.questions.length}`
    } else {
      return '0'
    }
  }

  async created() {
    this.fetchPaperDetail()
  }

  async fetchPaperDetail() {
    this.paperDetail = await AWinter2023.paperDetail(this.id)
  }

  assign() {
    this.selectPopupVisible = true
  }

  navToExamOrPracticeAssign(detail: ExamQuestionType) {
    if (detail === ExamQuestionType.TestByExam) {
      this.assignExamPopupVisible = true
    } else {
      this.assignPracticePopupVisible = true
    }
    this.selectPopupVisible = false
  }

  backTypeSelect() {
    this.assignPracticePopupVisible = false
    this.assignExamPopupVisible = false
    this.selectPopupVisible = true
  }
}
</script>
<style lang="less">
.knowledge-repo-page {
  > .main {
    padding: 16px;
    background: #fff;
    border-radius: 8px;
    box-sizing: border-box;
  }
}
</style>
